// SelectInput.js
import React from 'react';

const SelectInput = ({ label, name, value, onChange, options, required }) => {
    return (
        <div className="form-group">
            <label>{label} {required && <span>*</span>}</label>
            <select
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className="form-input"
            >
                {options.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
};

export default SelectInput;
